import React from 'react';
import { Slide } from '@material-ui/core';


const SlideUp= React.forwardRef(
  (props, ref) => <Slide direction="up" ref={ref} {...props} />,
);

export default SlideUp;



// WEBPACK FOOTER //
// ./src/components/controls/transitions/SlideUp.jsx